import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Switch from '@material-ui/core/Switch';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';

import Abc from '../Abc';
import AbcPlayer from '../AbcPlayer';
import Flute from '../instruments/Flute';
import Piano from '../instruments/PianoSvg';
import Guitar from '../instruments/Guitar';
import Xylophone from '../instruments/Xylophone';
import ErrorBoundary from '../ErrorBoundary';
import { INSTRUMENTS } from '../../lib/InstrumentHelper';
import PitchDetector from '../pitch/PitchDetector';
import VerbosePitchDetector from '../pitch/VerbosePitchDetector';
import PitchDetectionController from '../../lib/pitchDetectionController';
import NoteMatcherHelper from '../../lib/noteMatcherHelper';
import NoteMatcherView from '../noteMatcherView';
import TutorResults from '../TutorResults';
import { switch_classes } from '../../lib/classNames';
import { getOptions } from '../../lib/optionsHelper';
import Header from '../Main/Header';
import { ModeLinkButton } from '../ScoreList/index';
import BookProvider from '../../lib/bookProvider';

import EasyIcon from './ico_easy';

import { PRACTICE, TUTOR, EASYPLAY, MODE_LONG_TITLES, MODE_URLS, REVERSE_MODE_URLS } from '../../lib/modesHelper';
import Options from '../Options';

// valore di cambiamento minimo ai BPM
const MIN_DELTA_BPM = 1;
const MINIMUM_BPM = 40;

function Transition(props) {
  console.log("Transition",props)
  return <Slide direction="up" {...props} />;
}

class App extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  pitchDetectionController;
  noteMatcherHelper;

  constructor(props) {
    super(props);
    const mode = REVERSE_MODE_URLS[props.match.params.mode_id];
    if (!mode) {
      return;
    }
    this.state = {
      error: false,
      audio: true,
      instrument: mode === EASYPLAY ? 'xylophone' : false,
      notes: null,
      currentNote: null,
      score: null,
      drum:true,
      voicesOff: mode === TUTOR,
      chordsOff: mode === PRACTICE || mode === TUTOR,
      detectionText: '',
      title: '',
      // player
      duration: 100,
      currentTime: 0,
      bmp: 180,
      playing: false,
      // tutor:
      tutorResultsModalVisible: false,
      tutorConfigurationModalVisible: mode === TUTOR, // visibile per default in modalità TUTOR.
      optionPopperVisible: false,
      optionPopperAnchor: null,
      //
      scoreText: null,
      configurationModalVisible: false
    };
    this.lastNoteFromMic = null;
    this.editor = null;
    // Player:
    this.originalBpm = null; // forse ha senso spostare "tune" da dentro Abc.
    //
    const params = {
      onMicrophoneStateChanged: null,
      onWaveChanged: null,
      onNoteChanged: this.onNoteFromMicrophone
    };

    this.debugNoteMatcher = getOptions().debug;
    if (this.debugNoteMatcher) {
      params.debug = true;
    }

    if (mode === TUTOR) {
      this.pitchDetectionController = new PitchDetectionController(params);
      this.noteMatcherHelper = new NoteMatcherHelper(getOptions().tutorDetectionDelay);
      if (this.debugNoteMatcher) {
        this.noteMatcherHelper.defaultRightNoteCallback = (path, rightLength) => {
          if (rightLength) path.setAttribute('fill', '#8CDB03');
          else path.setAttribute('fill', '#6db33d');
        };
        this.noteMatcherHelper.defaultWrongNoteCallback = path => {
          path.setAttribute('fill', 'red');
        };
      }
    }
  }

  render() {
    const mode = REVERSE_MODE_URLS[this.props.match.params.mode_id];
    const score_id = this.props.match.params.score_id;
    const { duration, currentTime, bpm, playing } = this.state;
    const {
      currentNote,
      error,
      score,
      instrument,
      drum,
      voicesOff,
      chordsOff,
      optionPopperVisible,
      optionPopperAnchor,
      configurationModalVisible
    } = this.state;
    const title = score ? score.title : '';

    const scoreOptions = getOptions();
    const fixedConfigurations = mode === TUTOR || (score && score.advanced);
    if (fixedConfigurations) {
      scoreOptions.staffOrientation = 'vertical';
      scoreOptions.selectedStaffLine = -1;
      scoreOptions.noteLengthVisible = false;
      scoreOptions.notesNameVisible = false;
    }
    const { staffOrientation, noteLengthVisible, notesNameVisible } = scoreOptions;
    const horizontalScore = staffOrientation === 'horizontal';

    let cursorType = 'style';
    if (mode === EASYPLAY) {
      cursorType = 'arrow';
      if (horizontalScore && (noteLengthVisible || notesNameVisible)) {
        cursorType = 'easystyle';
      }
    }

    if (!mode) {
      return null;
    }
    if (error) {
      return <div>{error}</div>;
    }
    const header_classes = { Header: 'Mode-' + mode };
    let bodyClasses = 'Body Mode-' + mode + ""
    let tutorPaperScrollPaperClass = 'Tutor-Option-paperScrollPaper';
    if (this.pitchDetectionController && this.pitchDetectionController.micSourceEnabled)
      tutorPaperScrollPaperClass += ' dark';
    if (this.state.tutorConfigurationModalVisible ) bodyClasses += ' blurred';
    if (this.state.configurationModalVisible ) bodyClasses += ' blurred';
    const shouldInstrumentsBeShown = mode !== EASYPLAY && mode !== TUTOR;
    return [
      <Header key={1} classes={header_classes} karaokeMode={false} title={MODE_LONG_TITLES[mode]} />,
      <div key={2} className={bodyClasses}>
        <div className="Main-Column">
          <div className="Main-Column-Header main-column-margin">
            {this.debugNoteMatcher && (
              <NoteMatcherView controller={this.noteMatcherHelper} currentTime={currentTime} verbose={false} />
            )}
            {!this.debugNoteMatcher && [
              <h2 key={1} className="Main-Tune-Title">
                {title}
              </h2>,
              <div key={2} className={'InstrumentParent'}>
                <div className={'Instrument-List'}>
                  {shouldInstrumentsBeShown &&
                    score &&
                    score.instruments &&
                    score.instruments.map((value, i) => {
                      const selected = value === instrument;
                      let className = INSTRUMENTS[value].name;
                      if (selected) className += ' current';
                      return (
                        <button className={className} key={i} onClick={() => this.handleInstrument(value)}>
                          {INSTRUMENTS[value].name}
                        </button>
                      );
                    })}
                </div>
                {score && score.easy && (
                  <div id={'EasyLink'} className={shouldInstrumentsBeShown ? '' : ' hidden'}>
                    <ModeLinkButton score_id={score_id} mode={EASYPLAY} icon={<EasyIcon />} />
                  </div>
                )}
              </div>
            ]}
          </div>
          <div className="Main-Column-Inner">
            <div className="Main-Score">
              <div className="Left Flip">
                {instrument === 'flute' && mode !== EASYPLAY && (
                  <ErrorBoundary>
                    <Flute style={{ display: instrument === 'flute' && mode !== EASYPLAY ? 'block' : 'none' }} currentNote={currentNote} />
                  </ErrorBoundary>
                )}
              </div>

              <div className={'Abc-Score' + (horizontalScore ? ' Abc-Score-Horizontal' : '')}>
                {score && (
                  <ErrorBoundary>
                    <Abc
                      drum={drum}
                      score={score}
                      scoreOptions={scoreOptions}
                      voicesOff={voicesOff}
                      chordsOff={chordsOff}
                      showPlayCursor={true}
                      onNotePlay={this.onNotePlay}
                      cursorType={cursorType}
                      onTuneLoaded={this.onTuneLoaded}
                      playing={playing}
                      currentTime={currentTime}
                      rewindNeeded={this.rewindNeeded}
                      onAudioTimeUpdate={this.audioTimeUpdate}
                      onPlaybackFinished={this.playbackFinished}
                      showConfigurationButton={fixedConfigurations}
                      onConfigurationButtonClicked={this.toggleConfigurationDialog}
                      bpm={bpm}
                    />
                  </ErrorBoundary>
                )}
              </div>
            </div>
            <div className="Main-Instrument">
              {instrument === 'piano' && mode !== EASYPLAY && (
                <ErrorBoundary>
                  <Piano currentNote={currentNote} />
                </ErrorBoundary>
              )}
              {instrument === 'guitar' && mode !== EASYPLAY && (
                <ErrorBoundary>
                  <Guitar currentNote={currentNote} />
                </ErrorBoundary>
              )}
              {(instrument === 'xylophone' || mode === EASYPLAY) && (
                <ErrorBoundary>
                  <Xylophone currentNote={currentNote} />
                </ErrorBoundary>
              )}
            </div>
            <div className="Main-Player">
              <ErrorBoundary>
                <AbcPlayer
                  playing={playing}
                  duration={duration}
                  currentTime={currentTime}
                  bpm={bpm}
                  bpmPlusEnabled={bpm + MIN_DELTA_BPM <= this.originalBpm}
                  bpmMinusEnabled={bpm - MIN_DELTA_BPM >= MINIMUM_BPM}
                  bpmDelta={MIN_DELTA_BPM}
                  showTutorResultButton={mode === TUTOR && this.noteMatcherHelper.playedNotes.length !== 0}
                  showTutorConfigurationButton={mode === TUTOR}
                  showOptionPopup={mode !== TUTOR}
                  drum={drum}
                  onCurrentTimeChanged={this.changeCurrentTime}
                  onPlayingChanged={this.changePlayState}
                  onRewindClicked = {this.rewindNeeded}
                  onShowTutorResultsButton={this.toggleTutorResultsModal}
                  onShowTutorConfigurationButton={this.toggleTutorConfigurationModal}
                  onBpmChanged={this.changeBpm}
                  onToggleOptions={this.toggleOptionPopper}
                  onDrumChanged={value => {
                    this.setState({ drum: value });
                  }}
                />
              </ErrorBoundary>

              <Popper
                id="playerOptions"
                placement="top-end"
                open={optionPopperVisible}
                anchorEl={optionPopperAnchor}
                transition
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper>
                      <div className="checkbox-wrapper">
                        <div id="baseSwitch" className="PlayerOptionRow">
                          <label>Base</label>
                          <Switch
                            name="baseEnabled"
                            classes={switch_classes}
                            checked={!chordsOff}
                            onChange={this.onChordsChanged}
                            value="1"
                          />
                        </div>
                        <div id="melodySwitch" className="PlayerOptionRow">
                          <label>Melodia</label>
                          <Switch
                            name="melodyEnabled"
                            classes={switch_classes}
                            checked={!voicesOff}
                            onChange={this.onVoicesChanged}
                            value="1"
                          />
                        </div>
                      </div>
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </div>
          </div>
        </div>

        {mode === TUTOR && (
          <div>
            <Dialog
              classes={{
                root: 'Tutor-Options-Dialog',
                scrollPaper: 'MuiDialog-scrollPaper-MU',
                paperScrollPaper: tutorPaperScrollPaperClass
              }}
              fullScreen
              open={this.state.tutorConfigurationModalVisible}
              onClose={this.toggleTutorConfigurationModal}
              TransitionComponent={Transition}
            >
              {this.debugNoteMatcher ? (
                <VerbosePitchDetector
                  controller={this.pitchDetectionController}
                  onNoteChanged={this.onNoteFromMicrophone}
                  onClose={this.toggleTutorConfigurationModal}
                />
              ) : (
                <PitchDetector
                  controller={this.pitchDetectionController}
                  onNoteChanged={this.onNoteFromMicrophone}
                  onClose={this.toggleTutorConfigurationModal}
                />
              )}
            </Dialog>
            <Dialog
              classes={{
                root: 'Tutor-Options-Dialog',
                scrollPaper: 'MuiDialog-scrollPaper-MU',
                paperScrollPaper: 'Tutor-Option-paperScrollPaper'
              }}
              fullScreen
              open={this.state.tutorResultsModalVisible}
              onClose={this.toggleTutorResultsModal}
            >
              <TutorResults
                onClose={this.toggleTutorResultsModal}
                scoreText={this.state.scoreText}
                matcher={this.noteMatcherHelper}
                debug={this.debugNoteMatcher}
              />
            </Dialog>
          </div>
        )}

        <Dialog
          classes={{
            root: 'Abc-Options-Dialog',
            scrollPaper: 'MuiDialog-scrollPaper-MU',
            paperScrollPaper: 'Abc-Options-paperScrollPaper '
          }}
          fullScreen
          open={configurationModalVisible}
          TransitionComponent={Transition}
          onClose={this.toggleConfigurationDialog}
        >
          {configurationModalVisible && <Options onClose={this.toggleConfigurationDialog} />}
        </Dialog>
      </div>
    ];
  }

  componentDidMount() {
    if (this.checkMode()) {
      this.asynComponentDidMount().finally();
    }
  }

  componentWillUnmount() {
    this.pitchDetectionController && this.pitchDetectionController.stopMicrophone();
    this.noteMatcherHelper && this.noteMatcherHelper.reset();
  }

  checkMode() {
    const { match, history } = this.props;
    const { params } = match;
    if (!params.mode_id) {
      history.push(process.env.PUBLIC_URL + '/' + params.score_id + '/' + MODE_URLS.practice);
      return false;
    }
    return true;
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.asyncComponentWillReceiveProps(nextProps, nextContext).finally();
  }

  async asynComponentDidMount() {
    const { match } = this.props;
    const { score_id } = match.params;
    let score;
    try {
      score = await BookProvider.getScore(score_id);
    } catch (e) {
      this.setState({ error: 'Impossibile caricare lo spartito!' });
      return;
    }

    if (!score) {
      this.setState({ error: 'Spartito non trovato!' });
      return;
    }
    this.setState({ score });
  }

  async asyncComponentWillReceiveProps(nextProps, nextContext) {
    const { match } = this.props;
    const { match: nextMatch } = nextProps;
    if (match.params.score_id !== nextMatch.params.score_id || match.params.mode_id !== nextMatch.params.mode_id) {
      let score;
      try {
        score = await BookProvider.getScore(nextMatch.params.score_id);
      } catch (e) {
        this.setState({ error: 'Impossibile caricare lo spartito!' });
        return;
      }
      if (!score) {
        this.setState({ error: 'Spartito non trovato!' });
        return;
      }
      this.setState({ score });
    }
  }

  handleInstrument = instrument => {
    if (this.state.instrument === instrument) {
      this.setState({ instrument: false });
    } else {
      this.setState({ instrument });
    }
    window.dispatchEvent(new Event('resize'));
  };

  onNotePlay = (notes, measureChanged, lineChanged, note, path) => {
    if(path !== null ){
      const classes=  path.className.baseVal;
      if(classes.includes('note-muted')){
        return;
      }
    }
    if (this.noteMatcherHelper) {
      this.noteMatcherHelper.onPlayedNote(note, path);
    }
    this.setState({ notes, currentNote: note });
  };

  onNoteFromMicrophone = note => {
    this.lastNoteFromMic = note;
    if (!note) {
      return;
    }
    this.noteMatcherHelper.onListenedNote(note);
  };

  onChordsChanged = event => {
    this.setState({ chordsOff: !event.target.checked });
  };

  onVoicesChanged = event => {
    this.setState({ voicesOff: !event.target.checked });
  };

  onTuneLoaded = (tune, duration, melody) => {
    const lines = [];
    const title = tune.metaText.title;
    // bpm
    //lines.push(`Q: ${tune.getBpm()}`);
    const fractionToString = fraction => {
      return `${fraction.num}/${fraction.den}`;
    };
    // Meter fraction
    lines.push(`M: ${fractionToString(tune.getMeterFraction())}`);
    // score key:
    for (let i = 0; i < tune.lines.length; i++) {
      if (tune.lines[i].staff) {
        lines.push(`K: ${tune.lines[i].staff[0].key.root}`);
        break;
      }
    }
    // default note length:
    lines.push('L: 1/4');
    const generateText = (...lines) => {
      return lines.join('\n') + '\n';
    };
    this.originalBpm = tune.metaText.tempo.bpm;

    this.setState({
      title: title,
      detectionText: generateText(...lines),
      bpm: tune.metaText.tempo.bpm,
      duration: duration,
      scoreText: melody
    });

    console.log("Tune Loaded");
  };

  // Player:

  rewindNeeded = () => {
    this.changeCurrentTime(0)
  }

  changeCurrentTime = value => {
    this.setState({ currentTime: value });
  };

  changePlayState = async (value, cb) => {
    
    const change = { playing: value };
    if (value === this.state.playing) return;
    if (this.pitchDetectionController) {
      if (value) {
        await this.pitchDetectionController.getMicrophone();
        this.pitchDetectionController.params.onNoteChanged = this.onNoteFromMicrophone;
        this.noteMatcherHelper.reset();
        this.noteMatcherHelper.startTime = new Date().getTime();
      } else {
        this.pitchDetectionController.stopMicrophone();
        // se ho finito play e ho piu' di una nota suonata, mostro i risultati del tutor
        if (this.noteMatcherHelper.playedNotes.length !== 0) {
          change.tutorResultsModalVisible = true;
        }
      }
    }

    this.setState(change, cb);
  };

  changeBpm = value => {
    console.log(value);
    if (!value || value < 40 || value > this.originalBpm) return;
    if (this.pitchDetectionController) {
      this.pitchDetectionController.stopMicrophone();
    }
    this.setState({ bpm: value, playing: false });
  };

  // ABC playback callbacks:

  audioTimeUpdate = value => {
    // WORKAROUND: quando i bpm sono piu' alti non arriva eventCallback di fine playback. (TODO: fixare abcjs?)
    if (value >= this.state.duration) this.playbackFinished();
    this.setState({ currentTime: value });
  };

  playbackFinished = () => {
    if (this.pitchDetectionController) {
      this.pitchDetectionController.stopMicrophone();
    }
    this.setState({ playing: false }, () => {
      this.setState({ currentTime: 0 });
    });
  };

  // TUTOR:
  toggleTutorConfigurationModal = () => {
    this.setState({ tutorConfigurationModalVisible: !this.state.tutorConfigurationModalVisible }, () => {
      if (!this.state.tutorConfigurationModalVisible) {
        this.pitchDetectionController.params.onNoteChanged = this.onNoteFromMicrophone;
        this.noteMatcherHelper.tolerance_range = getOptions().tutorDetectionDelay;
      }
    });
  };

  toggleTutorResultsModal = () => {
    // se playing e results nascosti, allora stoppo il play.
    // solo quando si è fermato mostro result e gli faccio fare i conti.
    // altrimenti possiamo cambiare lo stato di results direttamente.
    if (this.state.playing && !this.state.tutorResultsModalVisible) {
      // stoppiamo il player, automaticamente compare la modale.
      this.changePlayState(false);
    } else {
      this.setState({ tutorResultsModalVisible: !this.state.tutorResultsModalVisible });
    }
  };

  toggleOptionPopper = target => {
    this.setState({ optionPopperVisible: !this.state.optionPopperVisible, optionPopperAnchor: target });
  };

  // CONFIGURATION MANAGEMENT:
  toggleConfigurationDialog = () => {
    // bisogna forzare uno stop al player. Se lo faccio da dentro Abc.js, non viene aggiornato lo stato degli oggetti
    // sopra. Questa chiamata è per dire al padre di cambiare playing a false (currentTime non sarebbe neanche necessario)
    // Pensare a come ristrutturare la logica per non dover chiamare cose da fuori.
    // - mettiamo la configurationDialog fuori da qui?
    // - abc.js tiene il comando globale del play?
    this.playbackFinished();
    this.setState({
      configurationModalVisible: !this.state.configurationModalVisible
    });
  };
}

export default App;
